<template>
  <select
    name="state"
    v-on:change="onChanged"
    v-model="valueInternal"
    class="browser-default e4s-input-field e4s-input-field--primary"
    :class="errorMessage.length > 0 ? 'e4s-input-field--error' : ''"
  >
    <option
      v-for="(propValue, prop) in eventTypes"
      :value="prop"
      :key="prop"
      v-text="propValue"
    ></option>
  </select>
</template>

<script setup lang="ts">
import { type PropType, ref, watch } from 'vue'
import type { EventType, EventTypeMap } from '@/common/common-models'

const props = defineProps({
  placeHolder: {
    type: String,
    default: () => {
      return ''
    }
  },
  value: {
    type: String as PropType<EventType | 'ALL'>,
    default: () => {
      return ''
    }
  },
  eventTypes: {
    type: Object as PropType<Partial<EventTypeMap>>,
    required: true
  },
  errorMessage: {
    type: String,
    default: ''
  }
})

//  define emits.
const emit = defineEmits<{
  (e: 'input', value: EventType | 'ALL'): void
}>()

const valueInternal = ref<EventType | 'ALL'>(props.value)

watch(
  () => props.value,
  (newValue) => {
    valueInternal.value = newValue
  },
  {
    immediate: true
  }
)

function onChanged() {
  emit('input', valueInternal.value)
}
</script>
